import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, Router } from '@angular/router';
import { catchError, map, Observable, of, take } from 'rxjs';
import { AdminRole } from '../enums';
import { CurrentUserService } from '../services';

export function roleGuard(
  roles: AdminRole[],
  redirectRoute: string,
  endpoint?: string,
): CanActivateFn {
  return () => {
    const currentUserService = inject(CurrentUserService);
    const router = inject(Router);

    const user$: Observable<{ roles: string[] }> =
      currentUserService.hasCurrentUser
        ? currentUserService.currentUser$
        : currentUserService.fetchCurrentUser$(endpoint);

    return user$.pipe(
      take(1),
      map<{ roles: string[] }, GuardResult>(
        (user) =>
          roles.some((role) => user.roles.includes(role)) ||
          router.createUrlTree([redirectRoute]),
      ),
      catchError(() => of(router.createUrlTree([redirectRoute]))),
    );
  };
}
